import { render } from "./RestaurantTables.vue?vue&type=template&id=1e929134"
import script from "./RestaurantTables.vue?vue&type=script&lang=js"
export * from "./RestaurantTables.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__